<template>
  <div>
    <dropdown-button ref="premierDD" class="ml-2" v-if="adminData.event.event_settings.premier_exhibitor_rules">
      <span slot="link" class="appearance-none flex items-center inline-block btn btn-blue">
        <span class="mr-1">Premier Exhibitor</span>
        <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path style="fill:white;" d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </span>
      <div slot="dropdown" class="bg-white shadow rounded border overflow-hidden" >
        <template v-if="!pointSettings.use_new_config">
          <template v-if="pointSettings.overall.group_shows">
            <div v-for="g in pointSettings.overall.group_shows" :key="g.group_name">
              <a @click="() => {$refs.premierDD.close(); viewResults(g)}" class="no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">View Results ({{g.group_name}})</a>
              <a @click="() => {$refs.premierDD.close(); downloadResults(g)}" class="no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">Download Results ({{g.group_name}})</a>
            </div>
          </template>
          <template v-else>
            <a @click="() => {$refs.premierDD.close(); viewResults(null)}" class=" no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">View Results</a>
            <a @click="() => {$refs.premierDD.close(); downloadResults(null)}" class="no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">Download Results</a>
          </template>
        </template>
        <template v-else>
          <a @click="() => {$refs.premierDD.close(); viewResults(null)}" class=" no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">View Results</a>
          <!--<a @click="() => {$refs.premierDD.close(); downloadResultsNew(null)}" class="no-underline block px-4 py-3 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500">Download Results</a>-->
        </template>
      </div>
    </dropdown-button>

    <b-modal ref="PremierExhibitorResults" title="Premier Exhibitor Points" no-close-on-backdrop>
      <a v-if="newResultsData" @click="() => {$refs.premierDD.close(); downloadResults(null)}" class="btn btn-blue">Download Results</a>
      <div v-if="pointSettings" class="px-4 pt-6 pb-8 mb-4 w-full">
        <template v-if="!pointSettings.use_new_config">
          <div v-for="(r, i) in premierExhibitorResults" :key="i" class="border-b p-2">
            <p class="text-lg">{{r.exhibitor_name}} ~ {{r.total_points}}</p>
            <div class='text-xs'>
              <p v-for="(c,j) in Object.keys(r.points_categories)" :key="j">
                {{c}}: {{r.points_categories[c].category_points}}
              </p>
            </div>
          </div>
          <div v-if="premierExhibitorResults.length === 0">
            No Data Yet Check back after results are added.
          </div>
        </template>
        <template v-else>
          <tabs>
            <tab v-for="(category, i) in Object.keys(newPremierExhibitorData)" :selected="i === 0" :key="i" :name="category">
              <div v-for="(r, i) in newPremierExhibitorData[category]" :key="i" class="border-b p-1">
                <p class="text-lg">{{r.exhibitor_name}}</p>
                <p class="font-bold">{{r.total_points}} Points</p>
                <div v-if="r.show_details" class="text-sm">
                  <div class="link" @click="hideDetails(r)">Hide Details</div>
                  <div v-for="(p, j) in r.points" :key="j">
                    {{ p.show_name }} ~ <span v-if="p.animal_id">{{ p.animal_id }}</span> - <span class="font-bold">{{ p.points }} Points</span>
                  </div>
                </div>
                <div v-else class="link" @click="showDetails(r)">Show Details</div>
                <!--<div class='text-xs'>
                  <p v-for="(c,j) in Object.keys(r.points_categories)" :key="j">
                    {{c}}: {{r.points_categories[c].category_points}}
                  </p>
                </div>-->
              </div>
            </tab>
          </tabs>
        </template>
      </div>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button class="btn-gray-outline btn-sm" variant="primary" @click="$refs.PremierExhibitorResults.hide()">
            Close
          </button>
        </div>
      </div>
    </b-modal>

    <DownloadData ref="downloadData"/>

  </div>
</template>

<script>
import DownloadData from '@/components/DownloadData'
import Vue from 'vue'

export default {
  components: {
    DownloadData
  },
  data () {
    return {
      resultsData: null,
      newResultsData: null,
      membershipData: [],
      championResults: [],
      selectedGroup: null,
      newPremierExhibitorData: {}
    }
  },
  methods: {
    getResults () {
      if (!this.resultsData) {
        if (this.pointSettings.use_new_config) {
          this.$store.state.apiInstance.get(`/points/premierExhibitor?event_id=${this.adminData.event.event_id}`)
            .then(response => {
              this.newResultsData = response.data.data
              this.calculateNewPremierExhibitor()
            })
        } else {
          this.$store.state.apiInstance.get(`/callFunction/premierExhibitorData?event_id=${this.adminData.event.event_id}`)
            .then(response => {
              this.resultsData = response.data.data.results_data
              this.membershipData = response.data.data.membership
              this.championResults = response.data.data.champion_results
              return this.resultsData
            })
        }
      } else {
        return this.resultsData
      }
    },
    async viewResults (group) {
      if (group) {
        this.selectedGroup = group
      } else {
        this.selectedGroup = null
      }
      await this.getResults()
      this.$refs.PremierExhibitorResults.show()
    },
    downloadResults () {
      this.$refs.downloadData.exportCSVFile(`${this.adminData.event.name}_Premier_Exhibitor`, this.dataExport, this.dataHeaders)
    },
    calculateNewPremierExhibitor () {
      if (this.newResultsData) {
        this.pointSettings.standings_calculations.forEach(sc => {
          let categoryResults = []
          let allPoints = this.newResultsData[sc.category]
          Object.keys(allPoints).forEach(key => {
            let exhibitorPoints = allPoints[key].sort((a, b) => b.points - a.points)
            let exhibitor = this.adminData.exhibitors.find(e => e.exhibitor_id === key)
            if (!exhibitor) {
              exhibitor = {
              }
            }
            let result = {
              exhibitor_name: exhibitor.first_name + ' ' + exhibitor.last_name,
              total_points: 0,
              points_categories: {},
              points: []
            }
            exhibitorPoints.forEach((p, i) => {
              if (i < (sc.max_entries_counted_per_show ? sc.max_entries_counted_per_show : exhibitorPoints.length + 1)) {
                result.total_points += p.points
                result.points.push(p)
              }
            })
            categoryResults.push(result)
          })
          Vue.set(this.newPremierExhibitorData, sc.category, categoryResults.sort((a, b) => b.total_points - a.total_points))
        })
      }
    },
    showDetails (r) {
      Vue.set(r, 'show_details', true)
    },
    hideDetails (r) {
      Vue.set(r, 'show_details', false)
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    pointSettings () {
      return this.adminData.event.event_settings.premier_exhibitor_rules
    },
    premierExhibitorResults () {
      let results = []
      if (this.resultsData) {
        this.resultsData.forEach(exhibitor => {
          let result = {
            exhibitor_id: exhibitor.exhibitor_id,
            exhibitor_name: exhibitor.entries[0].exhibitor_name,
            total_points: 0,
            points_categories: {

            }
          }
          exhibitor.entries.forEach(entry => {
            if (this.pointSettings.require_membership) {
              if (this.pointSettings.show_series_id) {
                const isMember = this.membershipData.some((element) => {
                  if (element.exhibitor_id === exhibitor.exhibitor_id) {
                    return true
                  }
                })
                if (!isMember) {
                  return
                } else {
                }
              } else if (!entry.entry_details[this.pointSettings.membership_field]) {
                return
              }
            }
            if (this.selectedGroup) {
              if (!this.selectedGroup.shows.includes(entry.show_id)) {
                return
              }
            }

            let pointCalc = this.pointSettings.point_calcs[entry.class_list_id]
            // Check for scratches later
            let showBook = this.championResults.find(show => {
              return show.show_id === entry.show_id
            })
            let c = showBook.show_book.find(cl => {
              return cl.classID === entry.class_id
            })
            let classSize = c.entries.filter(entry => {
              return entry.place !== 'SCRATCH'
            }).length

            if (pointCalc) {
              let countShow = true
              if (pointCalc.include_shows) {
                countShow = pointCalc.include_shows.includes(entry.show_id)
              }
              let countDivision = true
              if (pointCalc.exclude_divisions) {
                countDivision = !pointCalc.exclude_divisions.includes(entry.entry_details.division)
              }
              if (countShow && countDivision) {
                if (pointCalc.class_points.use_point_ranges) {
                  let oneToUse = {}
                  pointCalc.class_points.point_ranges.forEach(ps => {
                    if (classSize >= ps.start && classSize <= ps.end) {
                      oneToUse = ps
                    }
                  })
                  if (oneToUse) {
                    entry.premier_points = oneToUse.placings_points[entry.entry_details.place - 1] ? oneToUse.placings_points[entry.entry_details.place - 1] : oneToUse.default_points
                  }
                } else {
                  entry.premier_points = pointCalc.class_points.placings_points[entry.entry_details.place - 1] ? pointCalc.class_points.placings_points[entry.entry_details.place - 1] : pointCalc.class_points.default_points
                }
                entry.premier_category = pointCalc.category

                // Check for Division Points
                let cr = this.championResults.find(element => element.show_id === entry.show_id)
                if (cr) {
                  cr.show_book.forEach(c => {
                    if (c.winner && (c.settings ? c.settings.champion_type !== 'WRITE' : true)) {
                      if (c.winner.entry_id === entry.entry_id) {
                        let championSettings = pointCalc.overall_points
                        if (c.division !== 'Overall') {
                          championSettings = pointCalc.division_points
                        }
                        if (championSettings) {
                          if (championSettings.points) {
                            Object.keys(championSettings.points).forEach(k => {
                              const regex = new RegExp(k, 'gi')
                              if (c.class_name.match(regex)) {
                                let points = championSettings.points[k]
                                let overwritePoints = championSettings.overwrite_points
                                /* if (championSettings.minimums[k]) {
                                  points = show_points[c.winner.entry_id][championSettings.minimums[k].type] >= championSettings.minimums[k].value ? championSettings.minimums[k].points : points + show_points[c.winner.entry_id].points
                                  overwritePoints = true
                                } */
                                if (!overwritePoints) {
                                  // console.log(points)
                                  entry.premier_points += points
                                } else {
                                  entry.premier_points = points
                                }
                              }
                            })
                          }
                        }
                      }
                    }
                  })
                }
                if (result.points_categories[pointCalc.category]) {
                  result.points_categories[pointCalc.category].entries.push(entry)
                } else {
                  result.points_categories[pointCalc.category] = {
                    entries: [entry]
                  }
                }
              }
            }
          })
          Object.keys(result.points_categories).forEach(c => {
            let category = this.pointSettings.overall.categories[c]
            result.points_categories[c].entries.sort((a, b) => b.premier_points - a.premier_points)
            let categoryPoints = 0
            result.points_categories[c].entries.forEach((e, i) => {
              if (i >= category.entries_that_count) {
                e.premier_points = category.points_for_additional ? category.points_for_additional : 0
              }
              categoryPoints += e.premier_points
            })
            result.points_categories[c].category_points = categoryPoints
            result.total_points += categoryPoints
          })
          if (result.total_points) {
            results.push(result)
          }
        })
      }
      return results.sort((a, b) => b.total_points - a.total_points)
    },
    dataHeaders () {
      let headers = [
        {
          field: 'exhibitor_name',
          header: 'Exhibitor'
        },
        {
          field: 'total_points',
          header: 'Total Points'
        },
        {
          field: 'category',
          header: 'Category'
        }
      ]

      return headers
    },
    dataExport () {
      let data = []
      this.newPremierExhibitorData.Exhibitors.forEach(e => {
        let row = {
          exhibitor_name: e.exhibitor_name,
          total_points: e.total_points
        }
        data.push(row)
      })
      return data
    }
  }
}
</script>

<style>

</style>
